import { render, staticRenderFns } from "./BotBusinessDataCard.vue?vue&type=template&id=836c13a2"
import script from "./BotBusinessDataCard.vue?vue&type=script&lang=ts"
export * from "./BotBusinessDataCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports